export default "__VITE_ASSET__D2_1Ni7T__"